import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { loadCompanyDeptData } from '@/api/personnel-manager/dept';

/**
 * 选择部门组件
 */
export default {
  props: {
    value: {
      type: String | Number,
      default: null
    },
    // 是否允许清除，默认true
    clearable: {
      type: Boolean,
      default: true
    },
    // 是否初始化下拉选项，默认true
    autoInitOptions: {
      type: Boolean,
      default: true
    },
    companyId: {
      type: String,
      default: null
    },
    companyIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    areaId: {
      type: String,
      default: null
    },
    filterable: {
      type: Boolean,
      default: true
    },
    // 是否过滤禁用的节点，默认true
    filterDisableLevel: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        this.formData.selectedValue = value;
      }
    },
    companyId: {
      immediate: false,
      handler: function handler() {
        var _this = this;
        this.onChange(null);
        this.$nextTick(function () {
          _this.loadTreeData();
        });
      }
    },
    areaId: {
      immediate: false,
      handler: function handler() {
        var _this2 = this;
        this.onChange(null);
        this.$nextTick(function () {
          _this2.loadTreeData();
        });
      }
    }
  },
  data: function data() {
    return {
      treeData: [],
      treeProps: {
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true
      },
      formData: {
        selectedValue: null
      }
    };
  },
  created: function created() {
    this.initContent();
  },
  methods: {
    initContent: function initContent() {
      if (this.autoInitOptions) {
        this.loadTreeData();
      }
    },
    loadTreeData: function () {
      var _loadTreeData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return loadCompanyDeptData(this.companyId, this.areaId, this.companyIds);
            case 2:
              this.treeData = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadTreeData() {
        return _loadTreeData.apply(this, arguments);
      }
      return loadTreeData;
    }(),
    onInit: function onInit(val) {
      this.$emit('input', val);
      this.$emit('init', val);
    },
    onChange: function onChange(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
    /**
     * 获取选中节点（供外部调用）
     *
     * @param flag {boolean} 默认true
     * @return {Array|*}
     */
    getCheckedNodes: function getCheckedNodes() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!this.$refs['cascader']) {
        return [];
      }
      return this.$refs['cascader'].getCheckedNodes(flag);
    }
  }
};